import { render, staticRenderFns } from "./MyTodoCommentsModal.vue?vue&type=template&id=75ee8188&"
import script from "./MyTodoCommentsModal.vue?vue&type=script&lang=js&"
export * from "./MyTodoCommentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ee8188')) {
      api.createRecord('75ee8188', component.options)
    } else {
      api.reload('75ee8188', component.options)
    }
    module.hot.accept("./MyTodoCommentsModal.vue?vue&type=template&id=75ee8188&", function () {
      api.rerender('75ee8188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BPMeletronicSigned/modules/MyTodoCommentsModal.vue"
export default component.exports